import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './NotFoundPage.css';
import * as keyset from './NotFoundPage.i18n';

const i18n = i18nFactory(keyset);

const NotFoundPage = () => (
    <div className={Bem.cls('not-found-page')}>
        <h1 className={Bem.cls('not-found-page', 'title')}>{404}</h1>
        <div className={Bem.cls('not-found-page', 'subtitle')}>
            {i18n('be-sure-no-error')}
        </div>
        <div className={Bem.cls('not-found-page', 'text')}>{i18n('info')}</div>
    </div>
);

export { NotFoundPage };
